import { RBAClient } from 'rba-client'
const client = RBAClient.getInstance(require('@/api/config'))

// initial state
const state = {
  listing: {
    requestTimeout: null,
    requestLoading: false,
    columns: [
      'guid',
      'url',
      'eventTypes',
      // 'createdDatetime',
      // 'modifiedDatetime',
      'action'
    ],
    options: {
      initFilters: [],
      initialPage: 1,
      perPage: 10,
      orderBy: {
        ascending: true,
        column: null
      },
      requestFunction () {
        // clearTimeout(this.requestTimeout)
        return new Promise((resolve, reject) => {
          if (this.$store) {
            this.$store.commit('webhook/webhookTable', { requestLoading: true })
          }
          client.webhook
            .findWhere()
            .then((results) => {
              console.log(results)
              resolve({ data: results.data.webhooks, count: results.data.webhooks.length })
            })
            .catch((error) => {
              reject(error)
            })
        }).catch((e) => {
          this.dispatch('error', e)
        })
      },
      /* responseAdapter: function(resp) {
        // console.log('responseAdapter', resp);
        return { data: resp.data[0], count: resp.data[1] };
      }, */
      columnsClasses: {
        guid: 'col-xs-2',
        eventTypes: 'col-xs-2',
        action: 'col-xs-1'
      },
      sortable: [],
      filterable: false, // []
      filterByColumn: true,
      dateColumns: ['createdDatetime', 'modifiedDatetime'],
      dateFormat: 'DD/MMM/YYYY'
    }
  },
  event_types: [],
  search: {
    eventTypes: [],
    start: null,
    end: null
  }
}

// getters
const getters = {
  options (state, unusedGetters, unusedRootState, rootGetters) {
    // rootGetters.i18n.t()
    // console.log('this', this)
    // console.log('rootGetters', rootGetters)
    const { i18n } = rootGetters
    const { initFilters, initialPage, perPage, orderBy, requestFunction, columnsClasses, sortable, filterable, filterByColumn, dateColumns } = state.listing.options

    return {
      initFilters,
      initialPage,
      perPage,
      orderBy,
      requestFunction,
      columnsClasses,
      sortable,
      headings: {
        guid: i18n.t('webhook.listing.table.guid.label'),
        url: i18n.t('webhook.details.form.url.label'),
        eventTypes: i18n.t('webhook.details.form.eventTypes.label'),
        action: i18n.t('listing.table.action.label')
      },
      filterable,
      filterByColumn,
      dateColumns,
      texts: {
        count: i18n.t('listing.table.texts.count'),
        first: i18n.t('listing.table.texts.first'),
        last: i18n.t('listing.table.texts.last'),
        filter: i18n.t('listing.table.texts.filter'),
        filterPlaceholder: i18n.t('listing.table.texts.filterPlaceholder'),
        limit: i18n.t('listing.table.texts.limit'),
        page: i18n.t('listing.table.texts.page'),
        noResults: i18n.t('listing.table.texts.noResults'),
        noRequest: i18n.t('listing.table.texts.noRequest'),
        filterBy: i18n.t('listing.table.texts.filterBy'),
        loading: i18n.t('listing.table.texts.loading'),
        defaultOption: i18n.t('listing.table.texts.defaultOption'),
        columns: i18n.t('listing.table.texts.columns')
      }
    }
  }
}

// actions
const actions = {
  findOne (context, payload) {
    return client.webhook.findOne(payload)
  },
  async save (context, payload) {
    console.log(payload)
    if (payload.guid) {
      return client.webhook.update(payload.guid, {
        ...payload
      })
    } else {
      return client.webhook.create({
        ...payload
      })
    }
  },
  remove (context, payload) {
    return client.webhook.destroy(payload)
  },
  async getEventTypes ({ state, commit }) {
    if (state.event_types.length === 0) {
      commit('updateEventTypes', (await client.webhook.getAvailableEvent()).data || [])
      // clear cache after 10 mins
      setTimeout(() => {
        commit('updateEventTypes', [])
      }, 1000 * 600)
    }
    return state.event_types
  },
  async getLogs ({ commit }, payload) {
    commit('updateSearchCritira', payload)
    return await client.webhook.getLogs(
      payload.eventTypes,
      new Date(payload.start),
      new Date(new Date(payload.end).getTime() + (1000 * 60 * 60 * 24) - 1),
      payload.page,
      payload.size)
  },
  async resendEvent (_, payload) {
    return await client.webhook.resendEvent(payload)
  }
}

// mutations
const mutations = {
  // SET_RECORDS (state, payload) {
  //   state.records = payload
  // },
  // SET_SORT_COLUMN (state, payload) {
  //   state.orderby = payload
  // },
  // SET_SORT_DIRECTION (state, payload) {
  //   state.order = payload
  // },
  // SET_PAGE_NUM (state, payload) {
  //   state.page_num = payload
  // },
  'webhookTable/SET_DATA' (state, data) {
    console.log('webhookTable/SET_DATA', data)
  },
  'webhookTable/PAGINATION' (state, data) {
    console.log('webhookTable/PAGINATION', data)
  },
  'webhookTable/FILTER' (state, data) {
    console.log('webhookTable/FILTER', data)
  },
  'webhookTable/SORTED' (state, data) {
    console.log('webhookTable/SORTED', data)
  },
  'webhookTable/LOADING' (state, payload) {
    console.log('webhookTable/LOADING', payload)
    state.listing.options.initFilters = payload.query
    state.listing.options.initialPage = payload.page
    state.listing.options.perPage = payload.limit
    state.listing.options.orderBy.ascending = payload.ascending
    state.listing.options.orderBy.column = payload.orderBy
    // state.listing.requestLoading = true
  },
  'webhookTable/LOADED' (state, data) {
    console.log('webhookTable/LOADED', data)
    state.listing.requestLoading = false
  },
  'webhookTable/LIMIT' (state, data) {
    console.log('webhookTable/LIMIT', data)
  },
  'webhookTable/ERROR' (state, data) {
    console.log('webhookTable/ERROR', data)
    state.listing.requestLoading = false
  },
  'webhookTable/ROW_CLICK' (state, data) {
    console.log('webhookTable/ROW_CLICK', data)
  },
  'webhookTable' (state, { requestLoading }) {
    state.listing.requestLoading = requestLoading === undefined ? state.listing.requestLoading : requestLoading
  },
  'updateEventTypes' (state, new_event_types) {
    state.event_types = new_event_types
  },
  'updateSearchCritira' (state, { eventTypes, start, end }) {
    state.search.eventTypes = eventTypes ?? state.search.eventTypes
    state.search.start = start ?? state.search.start
    state.search.end = end ?? state.search.end
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
